import React, { PropsWithChildren } from 'react';

interface ReleaseContentProps extends PropsWithChildren {
  title?: string;
}

export const ReleaseContent: React.FC<ReleaseContentProps> = ({
  title,
  children,
}) => {
  return (
    <div className="flex flex-col bg-white rounded-lg shadow-md">
      <div className="flex flex-col p-3 bg-gray-200 rounded-tl-md rounded-tr-md">
        <span className="text-sm font-bold">{title}</span>
      </div>

      {children}
    </div>
  );
};
